export const rankingMovies = [
  { rank: 1, title: "星际迷航：新纪元", genre: "科幻", year: "2026", score: "9.5", tag: "NEW" },
  { rank: 2, title: "狂飙人生", genre: "剧情", year: "2026", score: "9.3", tag: "HOT" },
  { rank: 3, title: "夜幕追踪", genre: "悬疑", year: "2026", score: "9.1", tag: "" },
  { rank: 4, title: "长安秘闻录", genre: "古装", year: "2025", score: "8.9", tag: "" },
  { rank: 5, title: "极寒之地", genre: "冒险", year: "2025", score: "8.7", tag: "HOT" },
  { rank: 6, title: "青春不散场", genre: "青春", year: "2026", score: "8.6", tag: "" },
  { rank: 7, title: "暗影猎手", genre: "动作", year: "2025", score: "8.5", tag: "" },
];

export const mediaItems = [
  { title: "《星际迷航：新纪元》终极预告", category: "预告片", duration: "02:35", views: "128.6万" },
  { title: "幕后特辑：极寒之地拍摄花絮", category: "花絮", duration: "08:12", views: "56.3万" },
  { title: "本周必看：三大热门影片深度解析", category: "解说", duration: "15:40", views: "89.1万" },
  { title: "经典重温：《长安秘闻录》名场面", category: "剪辑", duration: "06:18", views: "203.7万" },
  { title: "新片速递：八月档期全预告合集", category: "合集", duration: "12:05", views: "312.4万" },
];

export const indexCategories = [
  { name: "动作大片", count: 1280, icon: "ri-sword-line" },
  { name: "喜剧天地", count: 965, icon: "ri-emotion-laugh-line" },
  { name: "爱情文艺", count: 743, icon: "ri-heart-line" },
  { name: "科幻世界", count: 612, icon: "ri-rocket-line" },
  { name: "悬疑惊悚", count: 534, icon: "ri-search-eye-line" },
  { name: "剧情佳作", count: 1089, icon: "ri-film-line" },
  { name: "纪录纪实", count: 387, icon: "ri-camera-line" },
  { name: "动漫精选", count: 856, icon: "ri-ghost-line" },
  { name: "战争史诗", count: 291, icon: "ri-shield-flash-line" },
];

export const carouselItems = [
  {
    title: "暑期档爆款合集",
    subtitle: "十部必看大片一次收齐",
    description: "从科幻巨制到温情文艺，精选今夏最受关注的十部院线级影片，高清画质、流畅播放，陪你度过完美暑假。",
  },
  {
    title: "高分悬疑片单",
    subtitle: "烧脑反转停不下来",
    description: "精心挑选豆瓣8.5分以上悬疑佳作，每一部都让你猜不到结局。夜幕降临，准备好被剧情彻底征服。",
  },
  {
    title: "国漫崛起专区",
    subtitle: "国产动画的黄金时代",
    description: "从《大圣归来》到《深海》，国漫精品持续上新。顶级制作、东方美学，每一帧都是壁纸级别的视觉盛宴。",
  },
  {
    title: "经典港片回顾",
    subtitle: "那个年代的光影记忆",
    description: "周星驰、成龙、王家卫……重温港片黄金年代的不朽经典。高清修复版，让回忆在清晰的画面中重新鲜活。",
  },
  {
    title: "奥斯卡获奖影片",
    subtitle: "殿堂级电影艺术鉴赏",
    description: "历年奥斯卡最佳影片、最佳外语片完整收录。在家就能享受殿堂级的观影体验，中文字幕、多语原声。",
  },
];

export const updateItems = [
  { date: "2026-07-31", title: "《星际迷航：新纪元》高清版上线", desc: "年度科幻巨制正式登陆久播影院，4K超清画质，中英双语字幕，即点即看。" },
  { date: "2026-07-30", title: "服务器全面升级完成", desc: "全网节点扩容至300+，观影流畅度提升40%，高峰期也能享受零缓冲体验。" },
  { date: "2026-07-29", title: "《狂飙人生》评分突破9.3", desc: "这部现实主义力作上线一周即获超50万次播放，观众口碑持续走高。" },
  { date: "2026-07-28", title: "八月片单提前预告", desc: "下月将有12部新片上线，涵盖科幻、悬疑、动画等多种类型，敬请期待。" },
  { date: "2026-07-27", title: "移动端适配全面优化", desc: "手机观影体验大幅提升，支持手势控制亮度音量，横竖屏自适应切换。" },
  { date: "2026-07-26", title: "《夜幕追踪》独家上线", desc: "全网首发悬疑力作，豆瓣开分9.1，网友直呼'今年最佳推理片'。" },
  { date: "2026-07-25", title: "观影专题「国产动画崛起」上线", desc: "收录近五年高分国产动画电影，从故事到画面全面解析国漫进步之路。" },
  { date: "2026-07-24", title: "播放器内核升级至V3.0", desc: "支持HDR画质与杜比音效，兼容更多设备，老旧机型也能流畅播放高清内容。" },
];

export const topicItems = [
  { name: "科幻巨制", count: 2345, hot: true },
  { name: "悬疑推理", count: 1892, hot: true },
  { name: "国产动画", count: 1654, hot: true },
  { name: "经典港片", count: 3102, hot: false },
  { name: "奥斯卡", count: 987, hot: false },
  { name: "暑期强档", count: 4521, hot: true },
  { name: "温情治愈", count: 876, hot: false },
  { name: "动作冒险", count: 2134, hot: false },
  { name: "纪录片", count: 543, hot: false },
];

export const cardItems = [
  { title: "星际迷航：新纪元", description: "人类首次跨星系远征，在未知星域遭遇前所未有的文明危机。宏大视效、深刻哲思，年度必看科幻史诗。", tag: "热播中", score: "9.5" },
  { title: "狂飙人生", description: "一个普通人在时代洪流中的挣扎与崛起。真实事件改编，每个镜头都在拷问人性的底线与光辉。", tag: "口碑爆棚", score: "9.3" },
  { title: "夜幕追踪", description: "连环失踪案背后隐藏着惊人真相。一位退休刑警独自追寻线索，却发现真相远比想象中更加黑暗。", tag: "全网首发", score: "9.1" },
  { title: "长安秘闻录", description: "大唐长安城，一桩离奇命案牵出朝堂暗流。古装悬疑巅峰之作，服化道精致考究，剧情环环相扣。", tag: "经典回顾", score: "8.9" },
  { title: "极寒之地", description: "极地科考队意外发现远古遗迹，一场关乎人类命运的冒险就此展开。震撼的极地风光与紧张剧情完美融合。", tag: "HOT", score: "8.7" },
  { title: "青春不散场", description: "五个高中好友的成长故事，欢笑与泪水交织。毕业十年后重聚，才发现青春从未真正离去。温暖治愈。", tag: "催泪推荐", score: "8.6" },
];

export const comments = [
  { name: "电影发烧友小王", content: "久播影院的画质真的没话说，4K看起来太爽了！更新速度也很快，基本上电影院下映没多久就能看到了。推荐给所有喜欢看电影的朋友！", date: "2026-07-30" },
  { name: "追剧小达人", content: "之前试过好几个平台，不是卡顿就是广告太多。久播影院完全没有这个问题，播放流畅得让我惊讶，而且界面简洁干净，找片也很方便。", date: "2026-07-29" },
  { name: "深夜观影人", content: "片库真的很全，很多小众文艺片和经典老片都能找到。最近在回顾港片经典，画质修复得很好。唯一的遗憾是希望纪录片能再多一些。", date: "2026-07-28" },
];

export const features = [
  { icon: "ri-4k-line", title: "超清画质", description: "支持4K超高清播放，HDR画质与杜比音效，让每一帧都清晰细腻，还原影院级观影体验。" },
  { icon: "ri-speed-line", title: "极速加载", description: "全网300+节点智能调度，智能预加载技术，点击即播无需等待，高峰期也能流畅观影。" },
  { icon: "ri-refresh-line", title: "每日更新", description: "片库每日更新，新片上线速度快，热门大片、经典佳作、小众文艺一应俱全。" },
  { icon: "ri-smartphone-line", title: "多端畅享", description: "电脑、平板、手机全平台自适应，随时随地想看就看，进度自动同步，观影不间断。" },
];

export const faqItems = [
  { question: "久播影院的影片需要付费吗？", answer: "久播影院所有影片均为免费在线观看，无需注册会员、无需付费。我们致力于为影迷提供高质量的免费观影体验，所有内容均通过合法渠道获取。" },
  { question: "为什么播放时不会卡顿缓冲？", answer: "我们采用了全球分布式CDN加速节点和智能码率自适应技术，系统会根据你的网络状况自动调整画质，确保播放始终流畅。同时我们的预加载机制会在你点开影片前提前缓存关键数据。" },
  { question: "支持哪些设备观看？", answer: "久播影院支持电脑（Windows/Mac）、平板（iPad/Android）、手机（iOS/Android）等几乎所有主流设备。无需下载APP，通过浏览器即可直接观看，界面会自动适配你的屏幕尺寸。" },
  { question: "影片画质怎么样？有中文字幕吗？", answer: "平台提供从720P到4K超清多种画质选择，默认推荐最适合你网络环境的清晰度。大部分影片配备高质量中文字幕，部分热门影片还提供中英双语字幕。" },
  { question: "片库更新频率如何？新片多久能看？", answer: "我们的内容团队每天都会更新片库，国内院线下映的热门影片通常在一个月内即可在平台观看。同时我们也会持续补充经典老片和海外佳作，确保片库的丰富性和时效性。" },
  { question: "需要下载播放器或插件吗？", answer: "完全不需要。久播影院采用纯网页播放技术，你只需要一个现代浏览器（推荐Chrome、Edge或Safari），无需安装任何播放器、插件或扩展程序，打开网页即可观看。" },
];

export const contactInfo = {
  description: "我们欢迎所有电影爱好者与久播影院取得联系。无论是影片推荐、内容反馈还是商务合作，你的每一条声音我们都认真倾听。",
};

export const aboutInfo = {
  title: "关于我们",
  content1: "久播影院成立于2023年，是一个专注于提供高清免费电影在线观看的综合影音平台。我们汇集了来自全球的海量电影资源，涵盖动作、科幻、剧情、悬疑、喜剧、动画等各类题材，致力于为每一位影迷打造极致的观影体验。",
  content2: "平台采用先进的流媒体传输技术和全球分布式加速网络，确保每一部影片都能以最佳画质流畅播放。我们的内容运营团队每日精心筛选和更新片库，让最新、最热的电影第一时间与观众见面。",
  content3: "无论你是在寻找院线新片、经典重温，还是探索小众文艺佳作，久播影院都是你值得信赖的观影伙伴。好电影，不等待。",
};

export const appInfo = {
  title: "随时随地 想看的都在这里",
  description: "无需下载APP，手机浏览器直接访问久播影院，即享完整观影功能。界面自动适配移动屏幕，支持手势控制亮度与音量，横竖屏无缝切换。收藏夹与播放进度云端同步，电脑没看完的，手机上接着看。",
};